<template>
  <b-container>
    <communicating-tables-lists
      :brick_id="brick_id"
      :rhs_title="$t('tables_to_compute')"
      :all_tables="tables_undeleted"
      :rhs_elements="parents_to_launch_ids"
      :element_constructor="rhs_table_structure"
      :disabled="changes_disabled"
      @input="maj($event)"
    >
      <template v-slot:rhs_table_component="slot_props">
        <b-list-group-item class="table-handle hand-pointer">
          <span class="fas fa-grip-vertical fa-fw" />
          {{ slot_props.element_name }}
        </b-list-group-item>
      </template>
    </communicating-tables-lists>
  </b-container>
</template>

<i18n>
{
  "en": {
    "tables_to_compute": "Liste of chosen tables to compute"
  },
  "fr": {
    "tables_to_compute": "Liste des tables à calculer"
  }
}
</i18n>

<script>
import _ from 'lodash'

import { BasicTableInfoEntity } from '@/components/object_model.js'

// import { subscription_mixin, brick_mixin } from '@/components/mixin.js'
import { global_brick_mixin } from '@/components/mixin.js'
import CommunicatingTablesLists from '@/components/communicating_tables_lists.vue'

// *****************************************************************************

export default {
  name: 'BrickFinish',
  components: {
    CommunicatingTablesLists,
  },
  // mixins: [subscription_mixin, brick_mixin],
  mixins: [global_brick_mixin],
  // props: [
  //   'brick_id',
  //   'project_id',
  //   'description_name',
  //   'metavariables_dicts_poids',
  // ],
  data() {
    return {
      rhs_table_structure: BasicTableInfoEntity,
      parents_to_launch_ids: [],
    }
  },

  computed: {
    adapted_data() {
      let adapted = {
        uid: this.brick_id,
        parents_info: this.parents_to_launch_ids,
      }

      _.assignIn(adapted, this.description_name)

      return adapted
    },
  },
  watch: {
    cur_brick: {
      immediate: true,
      handler(nv) {
        let cur_parents_to_launch_ids = this.cur_brick.parents_info
        if (!_.isEqual(cur_parents_to_launch_ids, this.parents_to_launch_ids)) {
          this.parents_to_launch_ids = _.cloneDeep(cur_parents_to_launch_ids)
        }
      },
    },
  },
  methods: {
    maj(event) {
      this.parents_to_launch_ids = _.cloneDeep(event)
    },
  },
}
</script>
